import '@/workchat/v3/components/WorkChatAvatar/WorkChatAvatar.scss';

interface WorkChatAvatarProps {
  avatarKey?: string;
  avatarUrl?: string | null;
  firstName?: string;
  lastName?: string;
  size?: 'small';
}

export default function WorkChatAvatar({ avatarKey, avatarUrl, firstName, lastName, size }: WorkChatAvatarProps) {
  const renderInitials = () => {
    let initials = '';
    if (firstName && lastName) {
      initials = [firstName.charAt(0), lastName.charAt(0)].join('');
    } else if (firstName) {
      initials = firstName.charAt(0);
    } else if (lastName) {
      initials = lastName.charAt(0);
    }

    return <div className="initials">{initials.toUpperCase()}</div>;
  };

  return (
    <div className={`WorkChatAvatar avatar ${size}`} key={avatarKey} data-testid={avatarKey}>
      {avatarUrl ? <img src={avatarUrl} alt="Avatar" /> : renderInitials()}
    </div>
  );
}
